/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexShrink: 0,
  gap: theme.spacing(2),
}));

export const Column = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const HelpBox = styled(Box)(({theme}) => ({
  width: '220px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const DescriptionBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const DescriptionText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const BadgeBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const Badge = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  minHeight: '24px',
  background: theme.palette.semantic_light?.surface.surface2,
  borderRadius: '12px',
  width: 'max-content',

  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
}));
